import React from 'react'

type Props = {
    onMouseDown : callback
}

export default class VDrag extends React.Component<Props, any> {

    constructor(props:Props) {
        super(props);

        this.state = {
            minHeightMode: false
        };
    }

    // componentDidMount() {
    //     this.node = ReactDOM.findDOMNode(this);
    // }

    setMinHeightMode = (value:any) => {
        if (this.state.minHeightMode !== value) {
            this.setState({
                minHeightMode: value
            });
        }
    }

    render() {
        return <div className={Classes("v-drag", {'min-height-mode': this.state.minHeightMode})} onMouseDown={this.props.onMouseDown}> </div>;
    }
}